import { render, staticRenderFns, recyclableRender, components } from "./details_she.vue?vue&type=template&id=af448f24&scoped=true&"
var renderjs
import script from "./details_she.vue?vue&type=script&lang=js&"
export * from "./details_she.vue?vue&type=script&lang=js&"
import style0 from "./details_she.vue?vue&type=style&index=0&id=af448f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af448f24",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details_she/details_she.vue"
export default component.exports